import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/App/index'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)